// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let TipBox = require("../../../../uikit/atoms/TipBox/TipBox.bs.js");
let JsxRuntime = require("react/jsx-runtime");

function QuietPropertyTipBoxes$StreetAddress(props) {
  return JsxRuntime.jsx(TipBox.make, {
    title: "Street address",
    children: JsxRuntime.jsx("p", {
      children: "The property address will not be shared with others. However, you must enter an exact street\n      address for matching purposes."
    })
  });
}

let StreetAddress = {
  make: QuietPropertyTipBoxes$StreetAddress
};

function QuietPropertyTipBoxes$PriceRange(props) {
  return JsxRuntime.jsx(TipBox.make, {
    title: "Price range",
    children: JsxRuntime.jsx("p", {
      children: "A tighter range will yield better results."
    })
  });
}

let PriceRange = {
  make: QuietPropertyTipBoxes$PriceRange
};

let TipBox$1;

exports.TipBox = TipBox$1;
exports.StreetAddress = StreetAddress;
exports.PriceRange = PriceRange;
/* TipBox Not a pure module */
